(() => {
  const variantSelect = document.querySelector('.product__variant-select');
  const optionSelects = document.querySelectorAll('.product__option');
  const priceElement = document.getElementById('product-price');

  if (!variantSelect || optionSelects.length === 0) return;

  const syncVariant = () => {
    const chosen = Array.from(optionSelects).map((s) => s.value);
    const target = Array.from(variantSelect.options).find((opt) => {
      return chosen.every((v) => opt.textContent.includes(v));
    });
    if (target) {
      variantSelect.value = target.value;
      // Update price
      if (priceElement) {
        const price = target.dataset.price;
        if (price) {
          priceElement.textContent = price;
        }
      }
    }
  };

  optionSelects.forEach((s) => s.addEventListener('change', syncVariant));
  syncVariant();

  // Thumbnail image switching
  const thumbs = document.querySelectorAll('.product__thumbs img');
  const mainImage = document.querySelector('.product__media-main');
  if (mainImage && thumbs.length > 0) {
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.src.replace(/width=\d+/, 'width=1400');
        mainImage.src = src;
      });
    });
  }
})();

// Cart functionality
(() => {
  const quantityInputs = document.querySelectorAll('.cart__quantity-input');
  const removeButtons = document.querySelectorAll('.cart__remove-btn');
  const subtotalElement = document.getElementById('cart-subtotal');
  const cartForm = document.querySelector('.cart form');
  const emptyState = document.getElementById('cart-empty-state');

  const checkIfEmpty = () => {
    const lines = document.querySelectorAll('.cart__line');
    if (lines.length === 0) {
      if (cartForm) cartForm.style.display = 'none';
      emptyState.style.display = 'block';
    }
  };

  const updateCart = async () => {
    try {
      const response = await fetch('/cart.json');
      const cart = await response.json();
      
      // Update subtotal
      const subtotal = (cart.total_price / 100).toLocaleString('en-GB', {
        style: 'currency',
        currency: 'GBP'
      });
      subtotalElement.textContent = subtotal;
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  };

  const updateLineItem = async (key, quantity) => {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: parseInt(quantity)
        })
      });

      if (quantity === 0) {
        // Remove the line element from DOM
        const lineElement = document.querySelector(`[data-line-key="${key}"]`);
        if (lineElement) {
          lineElement.remove();
        }
        checkIfEmpty();
      } else {
        // Update the line price
        const response = await fetch('/cart.json');
        const cart = await response.json();
        const item = cart.items.find(i => i.key === key);
        
        if (item) {
          const lineElement = document.querySelector(`[data-line-key="${key}"]`);
          const priceElement = lineElement.querySelector('[data-line-price]');
          const price = (item.final_line_price / 100).toLocaleString('en-GB', {
            style: 'currency',
            currency: 'GBP'
          });
          priceElement.textContent = price;
        }
      }

      // Update subtotal
      await updateCart();
    } catch (error) {
      console.error('Error updating line item:', error);
    }
  };

  // Quantity change listener
  quantityInputs.forEach((input) => {
    input.addEventListener('change', (e) => {
      const lineElement = e.target.closest('[data-line-key]');
      const lineKey = lineElement.dataset.lineKey;
      const quantity = e.target.value;
      
      updateLineItem(lineKey, quantity);
    });
  });

  // Remove button listener
  removeButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const lineKey = btn.dataset.lineKey;
      updateLineItem(lineKey, 0);
    });
  });
})();